/** 與工匠個人檔、CraftsmanSelectionModal 一致之服務縣市選項 */
export const TAIWAN_SERVICE_AREA_OPTIONS = [
  '台北市',
  '新北市',
  '桃園市',
  '台中市',
  '台南市',
  '高雄市',
  '基隆市',
  '新竹市',
  '新竹縣',
  '苗栗縣',
  '彰化縣',
  '南投縣',
  '雲林縣',
  '嘉義市',
  '嘉義縣',
  '屏東縣',
  '宜蘭縣',
  '花蓮縣',
  '台東縣',
  '澎湖縣',
  '金門縣',
  '連江縣',
] as const;

export type TaiwanServiceArea = (typeof TAIWAN_SERVICE_AREA_OPTIONS)[number];

export function normalizeServiceAreaText(value?: string): string {
  if (!value) return '';
  return value.normalize('NFKC').replace(/台灣|台湾/gi, '').replace(/\s+/g, '').trim();
}

/** 服務區域陣列是否涵蓋所選縣市（含「桃園」對「桃園市」） */
export function matchesServiceAreaList(
  areas: string[] | undefined | null,
  selectedCity: string
): boolean {
  const city = normalizeServiceAreaText(selectedCity);
  if (!city) return true;
  const list = (areas || []).map((a) => normalizeServiceAreaText(a)).filter(Boolean);
  if (list.length === 0) return false;
  const cityCore = city.replace(/[市縣]$/, '');
  return list.some((a) => {
    if (a.includes(city) || city.includes(a)) return true;
    const aCore = a.replace(/[市縣]$/, '');
    return aCore.length >= 2 && (a.includes(cityCore) || city.includes(aCore));
  });
}

export function companyMatchesServiceCity(
  serviceAreas: string[] | undefined | null,
  address: string | undefined | null,
  selectedCity: string
): boolean {
  if (!(selectedCity ?? '').trim()) return true;
  if (matchesServiceAreaList(serviceAreas, selectedCity)) return true;
  const addr = normalizeServiceAreaText(address || '');
  const city = normalizeServiceAreaText(selectedCity);
  if (!addr || !city) return false;
  const cityCore = city.replace(/[市縣]$/, '');
  return addr.includes(city) || (cityCore.length >= 2 && addr.includes(cityCore));
}

/** 若關鍵字本身是縣市名，可視為隱含縣市篩選 */
export function inferCityFromSearchTerm(term: string): string | null {
  const t = normalizeServiceAreaText(term);
  if (!t) return null;
  for (const city of TAIWAN_SERVICE_AREA_OPTIONS) {
    const c = normalizeServiceAreaText(city);
    const core = c.replace(/[市縣]$/, '');
    if (t === c || t === core || (core.length >= 2 && t.includes(core))) {
      return city;
    }
  }
  return null;
}
